import { createEffect, createEvent, createStore } from 'effector';
import { publicApi } from '@/lib/axios/instances';
import { setToken } from '@/utils/auth';

export const refreshTokenStarted = createEvent();
export const refreshTokenFx = createEffect(async () => {
  const res = await publicApi.post('/auth/refresh-tokens');
  const token = res.data.access_token;
  if (!token) throw new Error('No access token');
  setToken(token);
  return token;
});

export const $authState = createStore({ isRefreshing: false })
  .on(refreshTokenStarted, (state) => ({ ...state, isRefreshing: true }))
  .on(refreshTokenFx.finally, (state) => ({ ...state, isRefreshing: false }));
